const MERGE_FIELD_CATEGORIES = [
  {
    name: 'components.lexical.merge_fields.Contact Information',
    options: [
      {
        key: 'first_name',
        name: 'components.lexical.merge_fields.First Name',
        placeholder: 'components.lexical.merge_fields.#[First Name]',
        alwaysInclude: true
      },
      {
        key: 'last_name',
        name: 'components.lexical.merge_fields.Last Name',
        placeholder: 'components.lexical.merge_fields.#[Last Name]',
        alwaysInclude: true
      },
      {
        key: 'email',
        name: 'components.lexical.merge_fields.Email',
        placeholder: 'components.lexical.merge_fields.#[Email]',
        alwaysInclude: true
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Employment Information',
    options: [
      {
        key: 'job_title',
        name: 'components.lexical.merge_fields.Job Title',
        placeholder: 'components.lexical.merge_fields.#[Job Title]',
        alwaysInclude: true,
      },
      {
        key: 'start_date',
        name: 'components.lexical.merge_fields.Start Date',
        placeholder: 'components.lexical.merge_fields.#[Start Date]',
        fieldType: 'date',
        separator: true
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Compensation',
    options: [
      {
        key: 'salary',
        name: 'components.lexical.merge_fields.Salary (or pay rate)',
        placeholder: 'components.lexical.merge_fields.#[Salary]',
        fieldType: 'salary',
        defaultValue: {
          payRateUnit: 'year',
          payRateCurrency: 'CAD'
        }
      },
      {
        key: 'bonus_structure',
        name: 'components.lexical.merge_fields.Bonus Structure',
        placeholder: 'components.lexical.merge_fields.#[Bonus Structure]',
        fieldType: 'text_area'
      },
      {
        key: 'commission_structure',
        name: 'components.lexical.merge_fields.Commission Structure',
        placeholder: 'components.lexical.merge_fields.#[Commission Structure]',
        fieldType: 'text_area'
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Document Fields',
    options: [
      {
        key: 'expires_at',
        name: 'components.lexical.merge_fields.Offer Expiry Date',
        placeholder: 'components.lexical.merge_fields.#[Offer Expiry Date]',
        alwaysInclude: true,
        fieldType: 'date'
      }
    ]
  }
];

export default MERGE_FIELD_CATEGORIES;
